<form [formGroup]="formGroup()" class="name-form-row">
  <div class="name-form-row__fields">
    @if (showTitle() && titleFormControl(); as titleCtrl) {
      <div class="name-form-row__field">
        <app-validated-dropdown
          [label]="'general.nameTitle'"
          inputFormControlName="nameTitle"
          [inputFormControl]="titleCtrl"
          [loading]="!genericStore.allLoaded() || genericStore.nameTitlesEntities().length === 0"
          [optionsStamp]="genericStore.nameTitlesEntities().length"
        >
          @for (nameTitle of genericStore.nameTitlesEntities(); track nameTitle.code) {
            <option [value]="nameTitle.code">
              {{ nameTitle.localized | getLocalized }}
            </option>
          }
        </app-validated-dropdown>
      </div>
    }
    <div class="name-form-row__field">
      <app-validated-input
        [label]="'general.lastName'"
        inputFormControlName="lastName"
        [inputFormControl]="formGroup().controls.lastName"
      />
    </div>
    <div class="name-form-row__field">
      <app-validated-input
        [label]="'general.middleName'"
        inputFormControlName="middleName"
        [inputFormControl]="formGroup().controls.middleName"
      />
    </div>
    <div class="name-form-row__field">
      <app-validated-input
        [label]="'general.firstName'"
        inputFormControlName="firstName"
        [inputFormControl]="formGroup().controls.firstName"
      />
    </div>
  </div>
</form>
